import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/customCategories/all')
  },
  listByKeyWord(keyWord: string) {
    return Ajax.get('/api/productManagement/customCategories/listByKeyWord?keyWord=' + keyWord)
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/customCategories?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/customCategories/${id}`
      : '/api/productManagement/customCategories'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/customCategories/${id}`)
  },
  getTreeData() {
    return Ajax.get('/api/productManagement/customCategories/tree')
  }
}
